export default __webpack_public_path__ + "static/media/header4.ea4a4670.jpg";